import React from 'react';
import Head from 'next/head';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import Form from '../../components/Form';
import NevoBanner from '../../components/NevoBanner';

import styles from './styles.module.scss'
import ContactUsBackground from '../../public/assets/images/contact-us-background.jpg';


export default function HomeChargingPage()  {
  return (
    <>
      <Head>
        <title>Contact Us | Nevo Advisory</title>
      </Head>

      <Header black transparent />

      <PageHeader backgroundImage={ContactUsBackground.src}>
        <h1 className='page-header-h1'>Contact Us.</h1>
      </PageHeader>

      <div className={`${styles.contactUsPage} page-holder`}>
        <div className={styles.contentHolder}>
          <h1 className='middle-header'>{"We're here to help"}</h1>
          <p className={`${styles.contactText} text`}>Please feel free to reach out to us to ask any questions you may have about charging your electric vehicles or transitioning your fleet to EV. We have an expert team who have years of experience in helping larger and small organisations make big strategic moves like this.</p>
        </div>

        <Form />
      </div>

      <NevoBanner />
    
      <Footer />
    </>
  )
};
